const e = "Account", t = "Account Balance", n = "Account description", o = "Account ID", a = "Additions", r = "Adjustments", s = "Amount", i = "and", c = "Apply", u = "Back", d = "Balance account", l = "Balance account ID", p = "Booked", f = "Captured", y = "Category", m = "Chargebacks", h = "Close", g = "Contact support", T = "Contact support for help.", R = "Contact support for help and share error code %{requestId}", w = "Copied", b = "Copy", A = "Corrections", C = "Currency", P = "Date", F = "Date range", v = "Description", S = "Dismiss", N = "Download", x = "Downloading", W = "Email", O = "Entity was not found", D = "Transaction not found for the specified Account Holder", k = "Fees", I = "File", B = "Filter bar", q = "From", L = "Full", M = "Funds captured", Y = "Go back", E = "Grant issued", U = "Grant repayments", G = "Hide content", H = "ID", V = "Incomplete field", _ = "In progress", j = "Loading", z = "max", X = "min", Q = "Mobile", J = "Net payout", K = "Next Payouts", Z = "No data", $ = "No negative numbers allowed", ee = "No payouts found", te = "No reports found", ne = "No transactions found", oe = "Other", ae = "Paginated navigation", re = "Partial", se = "Payment ID", ie = "Payment method", ce = "Payout Details", ue = "Payout information is generated each day at midnight, UTC time.", de = "Payouts", le = "Pending", pe = "Please come back later.", fe = "Please, reach out to support for assistance.", ye = "Reach out to support", me = "Reference ID", he = "Refresh", ge = "Refunds", Te = "Refund payment", Re = "We couldn’t process the refund. Try again later.", we = "Something went wrong.", be = "Your customer will receive the money in a maximum of 40 days. When the refund is successful you will see a new Refund transaction on your list.", Ae = "Refund is sent!", Ce = "Amount to refund", Pe = "Refunds can take up to 40 days depending on the payment method. Fees are included.", Fe = "Refund %{amount}", ve = "Reason for refund", Se = "Reference", Ne = "Remaining amount", xe = "Report", We = "Reports are generated each day at midnight, UTC time.", Oe = "Reports", De = "Reset", ke = "Reversed", Ie = "Something went wrong.", Be = "Something went wrong. Try refreshing the page or come back later.", qe = "Status", Le = "Structured list", Me = "Subtractions", Ye = "Sum of same-day payouts", Ee = "Tabs", Ue = "The error code is %{requestId}", Ge = "There are no results", He = "The request is missing required fields or contains invalid data.", Ve = "There was an unexpected error", _e = "The selected balance account is incorrect", je = "Timezone", ze = "To", Xe = "Total incoming", Qe = "Total outgoing", Je = "To value should be equal or greater than the From value", Ke = "Transaction details", Ze = "Transactions", $e = "Transactions overview", et = "Transaction type", tt = "Transfers", nt = "Try a different search or reset your filters, and we’ll try again.", ot = "Try refreshing the page or come back later.", at = "Amount", rt = "Type", st = "Value", it = "We couldn't load the payouts overview.", ct = "We couldn't load the reports overview.", ut = "We couldn't load the transactions overview.", dt = "We couldn't load your balance accounts.", lt = "We couldn't load your payouts.", pt = "We couldn't load your reports.", ft = "We couldn't load your transactions.", yt = {
  account: e,
  accountBalance: t,
  accountDescription: n,
  accountID: o,
  additions: a,
  adjustments: r,
  amount: s,
  and: i,
  apply: c,
  back: u,
  balanceAccount: d,
  balanceAccountId: l,
  Booked: p,
  "button.clearAll": "Clear all",
  "calendar.controls": "Calendar navigation controls",
  "calendar.nextMonth": "Next month",
  "calendar.previousMonth": "Previous month",
  "calendar.timezone": "Timezone is set on: GMT%{offset} (%{time})",
  "capital.accountIsInactive": "Your account is inactive",
  "capital.actionNeeded": "Action needed",
  "capital.businessFinancing": "Business financing",
  "capital.businessFinancingOffer": "Business financing offer",
  "capital.businessFinancingSummary": "Business financing summary",
  "capital.closed": "Closed",
  "capital.couldNotContinueWithTheOffer": "We couldn't continue with the offer.",
  "capital.couldNotLoadFinancialOffers": "We couldn't load financial offers.",
  "capital.dailyRepaymentRate": "Daily repayment rate",
  "capital.daysAndDaysLeft": "%{days} days (%{daysLeft} days left)",
  "capital.expectedRepaymentPeriod": "Expected repayment period",
  "capital.failed": "Failed",
  "capital.fees": "Fees",
  "capital.fullyRepaid": "Fully repaid",
  "capital.goToTermsAndConditions": "Go to Terms & Conditions",
  "capital.grantID": "Grant ID",
  "capital.howMuchMoneyDoYouNeed": "How much money do you need?",
  "capital.inProgress": "In progress",
  "capital.legalSubtitleAU": "Adyen Capital is provided by Adyen Australia Pty Limited.",
  "capital.legalSubtitleEU": "Loans are issued by Adyen N.V.",
  "capital.legalSubtitleGB": "Loans are issued by Adyen N.V. represented by its London Branch.",
  "capital.legalSubtitleUS": "Loans are issued by Adyen N.V. San Francisco Branch and subject to credit approval.",
  "capital.maximumRepaymentPeriod": "Maximum repayment period",
  "capital.minimumRepaymentToRepayTheFinancingOnTime": "Minimum repayment every %{days} days to repay the financing on time",
  "capital.needSomeExtraMoney": "Need some extra money?",
  "capital.offerLegalNoticeDescriptionUS": "If your application for business credit is denied, you have the right to a written statement of the specific reasons for the denial. To obtain the statement, please contact Adyen's Credit Support Team by emailing %{email} within 60 days from the date you are notified of our decision. We will send you a written statement of reasons for the denial within 30 days of receiving your request for the statement. %{break} The Federal Equal Credit Opportunity Act prohibits creditors from discriminating against credit applicants on the basis of race, color, religion, national origin, sex, marital status, age (provided that the applicant has the legal capacity to enter into a binding contract), because all or part of the applicant's income derives from any public assistance program, or because the applicant has in good faith exercised any right under the Consumer Credit Protection Act. The federal agency that administers compliance with this law concerning this creditor is the Office of the Comptroller of the Currency (OCC), 400 7th Street, SW Washington, DC 20219.",
  "capital.offerLegalNoticeTitleUS": "Creditor: Adyen N.V. – San Francisco Branch %{break} 505 Brannan Street, San Francisco, CA 94107.",
  "capital.oneMonth": "1 month",
  "capital.pending": "Pending",
  "capital.primaryAccount": "Primary account",
  "capital.remaining": "Remaining",
  "capital.remainingAmount": "Remaining amount",
  "capital.remainingFees": "Remaining fees",
  "capital.repaid": "Repaid",
  "capital.repaidAmount": "Repaid amount",
  "capital.repaidFees": "Repaid fees",
  "capital.repaymentThreshold": "Repayment threshold",
  "capital.requestedFunds": "Requested funds",
  "capital.requestFunds": "Request funds",
  "capital.requesting": "Requesting",
  "capital.reviewOffer": "Review offer",
  "capital.revoked": "Revoked",
  "capital.seeNewOffer": "See new offer",
  "capital.seeOptions": "See options",
  "capital.signTermsAndConditionsToReceiveFunds": "Sign the Terms & Conditions to receive your funds.",
  "capital.signTheTermsToReceiveYourFunds": "Sign the terms to receive your funds",
  "capital.termEnds": "Term ends: ",
  "capital.thereIsNoPrimaryAccountConfigured": "There is no primary account configured",
  "capital.thisOfferExpiresOn": "This offer expires on %{date}.",
  "capital.totalFees": "Total fees",
  "capital.totalRepaymentAmount": "Total repayment amount",
  "capital.unsupportedRegionDescription": "Business financing isn’t available in your region yet, but check back here for an offer.",
  "capital.unsupportedRegionTitle": "Stay tuned!",
  "capital.weCouldNotContinueWithTheOffer": "We couldn't continue with the offer.",
  "capital.weCouldNotContinueWithTheOfferContactSupportForHelp": "We couldn't continue with the offer. Contact support for help.",
  "capital.weCouldNotLoadFinancialOffers": "We couldn't load financial offers.",
  "capital.weCouldNotProcessThisRequestTryAgain": "We couldn't process this request. Try again with a new offer.",
  "capital.weReceivedYourRequestAndWeAreWorkingOnItNowCheckBackSoon": "We received your request and we’re working on it now. Check back soon for the next steps.",
  "capital.writtenOff": "Written off",
  "capital.xDays": "%{days} days",
  "capital.xMonths": "%{months} months",
  "capital.xPercent": "%{percentage}%",
  "capital.youAcceptedButThenReturnedTheseFunds": "You accepted but then returned these funds",
  "capital.youAcceptedTheseFundsButDidNotRepayThem": "You accepted these funds but did not repay them",
  "capital.youAreRequestingFundingOf": "You’re requesting funding of",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part1": "You have been pre-qualified for business financing",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part2": " up to %{amount}.",
  "capital.yourRequestedFundsWere": "Your requested funds were: ",
  "capital.youShouldGetTheFundsWithinOneBusinessDay": "You should get the funds within one business day",
  "capital.youWillNeedToRepayAMinimumOfXEveryXDaysToPayOffTheFunds": "You will need to repay a minimum of %{amount} every %{days} days to fully pay off the funds by %{date}.",
  "capital.youWillSoonQualifyForAFinancialOffer": "You will soon qualify for a financial offer!",
  capture: f,
  category: y,
  chargeback: m,
  closeIconLabel: h,
  contactSupport: g,
  contactSupportForHelp: T,
  contactSupportForHelpAndShareErrorCode: R,
  copied: w,
  copy: b,
  correction: A,
  currency: C,
  date: P,
  dateRange: F,
  default: "Default",
  description: v,
  dismiss: S,
  download: N,
  downloading: x,
  email: W,
  entityWasNotFound: O,
  entityWasNotFoundDetail: D,
  "error.pleaseTryAgainLater": "Please try again later.",
  "error.somethingWentWrongWithDownload": "Something went wrong with the download",
  "expandableCard.collapse": "Collapse",
  "expandableCard.expand": "Expand",
  export: "Export",
  fee: k,
  file: I,
  "filter.date.since": "Since %{date}",
  "filter.date.until": "Until %{date}",
  filterBar: B,
  "filterPlaceholder.category": "Type",
  "filterPlaceholder.currency": "Currency",
  "filterPlaceholder.status": "Status",
  from: q,
  full: L,
  fundsCaptured: M,
  goBack: Y,
  grantIssued: E,
  grantRepayment: U,
  hideContent: G,
  id: H,
  incompleteField: V,
  inProgress: _,
  loading: j,
  max: z,
  min: X,
  mobile: Q,
  netPayout: J,
  nextPayouts: K,
  noData: Z,
  noNegativeNumbersAllowed: $,
  noPayoutsFound: ee,
  noReportsFound: te,
  noTransactionsFound: ne,
  other: oe,
  paginatedNavigation: ae,
  "pagination.nextPage": "Next page",
  "pagination.previousPage": "Previous page",
  "pagination.showing": "Showing",
  partial: re,
  paymentId: se,
  paymentMethod: ie,
  payoutDetails: ce,
  payoutsNotice: ue,
  payoutsTitle: de,
  Pending: le,
  pleaseComeBackLater: pe,
  pleaseReachOutToSupportForAssistance: fe,
  "rangePreset.custom": "Custom",
  "rangePreset.last30Days": "Last 30 days",
  "rangePreset.last7Days": "Last 7 days",
  "rangePreset.lastMonth": "Last month",
  "rangePreset.lastWeek": "Last week",
  "rangePreset.thisMonth": "This month",
  "rangePreset.thisWeek": "This week",
  "rangePreset.yearToDate": "Year to date",
  reachOutToSupport: ye,
  referenceID: me,
  refresh: he,
  refund: ge,
  "refund.amountAlreadyRefunded": "You already refunded %{amount}",
  "refund.amountFailed": "The refund for %{amount} has failed. It is not currently possible to refund this amount. Please contact support.",
  "refund.amountInProgress": "The partial refund of %{amount} is being processed.",
  "refund.fee": "Fee",
  "refund.fullAmountFailed": "It is not possible to refund this payment. Please contact support.",
  "refund.fullAmountRefunded": "The full amount has been refunded back to the customer",
  "refund.goToPayment": "Go to payment",
  "refund.maximumRefundable": "You can only refund a maximum of %{amount}",
  "refund.onlyRefundable": "You can only refund %{amount}",
  "refund.originalAmount": "Original Amount",
  "refund.originalPayment": "Original Payment",
  "refund.paymentPspReference": "Payment PSP Reference",
  "refund.pspReference": "PSP Reference",
  "refund.refundFee": "Refund Fee",
  "refund.refundPspReference": "Refund PSP Reference",
  "refund.returnToRefund": "Return to refund",
  "refund.theRefundIsBeingProcessed": "The refund is being processed.",
  refundAction: Te,
  refundActionErrorSubtitle: Re,
  refundActionErrorTitle: we,
  refundActionSuccessSubtitle: be,
  refundActionSuccessTitle: Ae,
  refundAmount: Ce,
  "refundAmount.excess": "You cannot exceed the available amount of %{amount}",
  "refundAmount.required": "Enter a refund amount",
  "refunded.full": "Fully refunded",
  "refunded.partial": "Partially refunded",
  refundNotice: Pe,
  refundPayment: Fe,
  refundReason: ve,
  "refundReason.duplicate": "Duplicate",
  "refundReason.fraudulent": "Fraudulent",
  "refundReason.issue_with_item_sold": "Issue with item sold",
  "refundReason.other": "Other",
  "refundReason.requested_by_customer": "Requested by customer",
  refundReference: Se,
  "refundReference.placeholder": "Enter the reference here",
  remainingAmount: Ne,
  report: xe,
  "reportsError.tooManyDownloads": "We couldn't download all the files. Please try again later.",
  reportsNotice: We,
  reportsTitle: Oe,
  "reportType.payout": "Payout",
  reset: De,
  Reversed: ke,
  "select.filter.placeholder": "Placeholder",
  "select.noOptionsFound": "No options match this search",
  somethingWentWrong: Ie,
  somethingWentWrongTryRefreshingOrComeBackLater: Be,
  status: qe,
  structuredList: Le,
  subtractions: Me,
  sumOfSameDayPayouts: Ye,
  tabs: Ee,
  theErrorCodeIs: Ue,
  thereAreNoResults: Ge,
  theRequestIsMissingRequiredFieldsOrContainsInvalidData: He,
  thereWasAnUnexpectedError: Ve,
  theSelectedBalanceAccountIsIncorrect: _e,
  timezone: je,
  to: ze,
  "tooltip.ATM": "Money withdrawn at an ATM",
  "tooltip.Capital": "Money from an incoming loan grant or outgoing loan repayment",
  "tooltip.Chargeback": "Money returned to a customer after a disputed transaction",
  "tooltip.Correction": "Adjustments to your funds, including transaction reversals and deposit corrections",
  "tooltip.Fee": "Transaction costs and payment method fees",
  "tooltip.Other": "Transactions not in another category, usually an adjustment",
  "tooltip.Payment": "Money received to your account from a sales transaction",
  "tooltip.Refund": "Money sent back to a customer from a refunded transaction",
  "tooltip.totalIncoming": "All money received into your account based on the selected filters",
  "tooltip.totalOutgoing": "All fees, refunds, payouts, and other charges based on the selected filters",
  "tooltip.Transfer": "Money moved between your account and another account",
  totalIncoming: Xe,
  totalOutgoing: Qe,
  toValueShouldBeGreaterThanTheFromValue: Je,
  transactionDetails: Ke,
  transactions: Ze,
  transactionsOverviewTitle: $e,
  transactionType: et,
  transfer: tt,
  tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain: nt,
  tryRefreshingThePageOrComeBackLater: ot,
  txAmount: at,
  "txType.ATM": "ATM",
  "txType.Capital": "Capital",
  "txType.Chargeback": "Chargeback",
  "txType.Correction": "Correction",
  "txType.Fee": "Fee",
  "txType.Other": "Other",
  "txType.Payment": "Payment",
  "txType.Refund": "Refund",
  "txType.Transfer": "Transfer",
  type: rt,
  value: st,
  weCouldNotLoadThePayoutsOverview: it,
  weCouldNotLoadTheReportsOverview: ct,
  weCouldNotLoadTheTransactionsOverview: ut,
  weCouldNotLoadYourBalanceAccounts: dt,
  weCouldNotLoadYourPayouts: lt,
  weCouldNotLoadYourReports: pt,
  weCouldNotLoadYourTransactions: ft
};
export {
  p as Booked,
  le as Pending,
  ke as Reversed,
  e as account,
  t as accountBalance,
  n as accountDescription,
  o as accountID,
  a as additions,
  r as adjustments,
  s as amount,
  i as and,
  c as apply,
  u as back,
  d as balanceAccount,
  l as balanceAccountId,
  f as capture,
  y as category,
  m as chargeback,
  h as closeIconLabel,
  g as contactSupport,
  T as contactSupportForHelp,
  R as contactSupportForHelpAndShareErrorCode,
  w as copied,
  b as copy,
  A as correction,
  C as currency,
  P as date,
  F as dateRange,
  yt as default,
  v as description,
  S as dismiss,
  N as download,
  x as downloading,
  W as email,
  O as entityWasNotFound,
  D as entityWasNotFoundDetail,
  k as fee,
  I as file,
  B as filterBar,
  q as from,
  L as full,
  M as fundsCaptured,
  Y as goBack,
  E as grantIssued,
  U as grantRepayment,
  G as hideContent,
  H as id,
  _ as inProgress,
  V as incompleteField,
  j as loading,
  z as max,
  X as min,
  Q as mobile,
  J as netPayout,
  K as nextPayouts,
  Z as noData,
  $ as noNegativeNumbersAllowed,
  ee as noPayoutsFound,
  te as noReportsFound,
  ne as noTransactionsFound,
  oe as other,
  ae as paginatedNavigation,
  re as partial,
  se as paymentId,
  ie as paymentMethod,
  ce as payoutDetails,
  ue as payoutsNotice,
  de as payoutsTitle,
  pe as pleaseComeBackLater,
  fe as pleaseReachOutToSupportForAssistance,
  ye as reachOutToSupport,
  me as referenceID,
  he as refresh,
  ge as refund,
  Te as refundAction,
  Re as refundActionErrorSubtitle,
  we as refundActionErrorTitle,
  be as refundActionSuccessSubtitle,
  Ae as refundActionSuccessTitle,
  Ce as refundAmount,
  Pe as refundNotice,
  Fe as refundPayment,
  ve as refundReason,
  Se as refundReference,
  Ne as remainingAmount,
  xe as report,
  We as reportsNotice,
  Oe as reportsTitle,
  De as reset,
  Ie as somethingWentWrong,
  Be as somethingWentWrongTryRefreshingOrComeBackLater,
  qe as status,
  Le as structuredList,
  Me as subtractions,
  Ye as sumOfSameDayPayouts,
  Ee as tabs,
  Ue as theErrorCodeIs,
  He as theRequestIsMissingRequiredFieldsOrContainsInvalidData,
  _e as theSelectedBalanceAccountIsIncorrect,
  Ge as thereAreNoResults,
  Ve as thereWasAnUnexpectedError,
  je as timezone,
  ze as to,
  Je as toValueShouldBeGreaterThanTheFromValue,
  Xe as totalIncoming,
  Qe as totalOutgoing,
  Ke as transactionDetails,
  et as transactionType,
  Ze as transactions,
  $e as transactionsOverviewTitle,
  tt as transfer,
  nt as tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain,
  ot as tryRefreshingThePageOrComeBackLater,
  at as txAmount,
  rt as type,
  st as value,
  it as weCouldNotLoadThePayoutsOverview,
  ct as weCouldNotLoadTheReportsOverview,
  ut as weCouldNotLoadTheTransactionsOverview,
  dt as weCouldNotLoadYourBalanceAccounts,
  lt as weCouldNotLoadYourPayouts,
  pt as weCouldNotLoadYourReports,
  ft as weCouldNotLoadYourTransactions
};
